import React from 'react';
import { Input } from '../Input';
import { spacing } from '../../theme/spacing';
import { typography } from '../../theme/typography';
import { colors } from '../../theme/colors';

interface Step4Props {
    data: any; // Using loose type or WizardState['contact']
    onChange: (data: any) => void;
}

export const Step4: React.FC<Step4Props> = ({ data, onChange }) => {

    const update = (updates: any) => {
        onChange({ ...data, ...updates });
    };

    const titleStyle: React.CSSProperties = {
        fontFamily: typography.fontFamily,
        fontSize: '28px',
        fontWeight: typography.weights.bold,
        color: colors.text.primary,
        marginBottom: spacing[12],
        marginTop: 0,
    };

    const helperStyle: React.CSSProperties = {
        fontFamily: typography.fontFamily,
        fontSize: '16px',
        color: colors.text.muted,
        marginBottom: spacing[48],
        lineHeight: 1.6,
    };

    const gridStyle: React.CSSProperties = {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: spacing[24],
    };

    return (
        <div>
            <h2 style={titleStyle}>Miten saamme sinut kiinni?</h2>
            <p style={helperStyle}>
                Jätä yhteystietosi, niin voimme vahvistaa huoltoajan ja pitää sinut kartalla.
            </p>

            <div style={gridStyle}>
                <Input
                    label="Etunimi"
                    placeholder="Esim. Matti"
                    value={data.firstName || ''}
                    onChange={(e) => update({ firstName: e.target.value })}
                />
                <Input
                    label="Sukunimi"
                    placeholder="Esim. Meikäläinen"
                    value={data.lastName || ''}
                    onChange={(e) => update({ lastName: e.target.value })}
                />
                <div style={{ gridColumn: '1 / -1' }}>
                    <Input
                        label="Sähköposti"
                        placeholder="esim.nimi@email.fi"
                        value={data.email || ''}
                        onChange={(e) => update({ email: e.target.value })}
                    />
                </div>
                <div style={{ gridColumn: '1 / -1' }}>
                    <Input
                        label="Puhelinnumero"
                        placeholder="040 123 4567"
                        value={data.phone || ''}
                        onChange={(e) => update({ phone: e.target.value })}
                    />
                </div>
                <div style={{ gridColumn: '1 / -1' }}>
                    <Input
                        label="Lisätiedot (valinnainen)"
                        placeholder="Jos haluat kertoa jotain lisää..."
                        helperText="Esim. erityistoiveita huollon ajankohdasta tai muuta oleellista."
                        value={data.notes || ''} // Note: WizardState doesn't explicit have notes in Contact, but payloadBuilder handles it if we map it or just use it. 
                        // Actually payloadBuilder uses customer_notes FROM timeAndDelivery.notes (pickup notes) mostly.
                        // Let's check payloadBuilder again...
                        // It maps `customer_notes` to `notes` constructed from pickup data.
                        // But Step 4 has "Lisätiedot". We should add `notes` to `contact` in WizardState and use it.
                        // I will add it to state update here.
                        onChange={(e) => update({ notes: e.target.value })}
                    />
                </div>
            </div>
        </div>
    );
};
